import { useEffect } from 'react';
import { useDragDropManager } from 'react-dnd';

export function ScrollOnDrag() {
  const dragDropManager = useDragDropManager();
  const monitor = dragDropManager.getMonitor();

  useEffect(() => {
    const offsetChangeHandler = () => {
      if (monitor.isDragging()) {
        const offset = monitor.getClientOffset();
        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        if ((offset?.y + 200) > vh) {
          window.scrollBy(0, 20);
        }
        if ((offset?.y) < 200) {
          window.scrollBy(0, -20);
        }
      }
    };
    const unsubscribeOffsetChange = monitor.subscribeToOffsetChange(offsetChangeHandler);
    return () => {
      unsubscribeOffsetChange();
    };
  }, [monitor]);

}
